export default __webpack_public_path__ + "static/media/box_icon.ea00a09e.svg";